import type { JSX, PropsWithChildren } from 'react';

import styles from './Container.module.css';

export default function Container({
  children,
}: PropsWithChildren): JSX.Element {
  return <div className={styles.Container}>{children}</div>;
}
